export default __webpack_public_path__ + "static/Entenda0093-0256c9a38ddfc664bb5be1105847c86a.jpg";